<template>
  <div class="app-input-telefone w-full">
    <vs-input
      :label="label"
      :name="name"
      type="tel"
      :disabled="disabled"
      :color="color"
      :size="size"
      :placeholder="placeholder"
      :maxlength="15"
      v-mask="computedMask"
      v-model="innerValue"
      v-validate="computedValidationRules"
      class="inputx w-full"
      @input="onInput"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
    />
    <span
      class="ml-2 text-danger text-xs"
      style="font-size: 11px;"
      v-show="errors && errors.has(name)"
    >
      {{ errors.first(name) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'AppInputTelefone',
  inject: {
    $validator: {
      default: null
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: 'Telefone'
    },
    name: {
      type: String,
      default: 'telefone'
    },
    placeholder: {
      type: String,
      default: '(00) 0000-0000'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: String,
      default: 'normal'
    },
    customRules: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      innerValue: this.value || ''
    };
  },
  computed: {
    computedMask() {
      const numbers = (this.innerValue || '').replace(/\D/g, '');
      // <= 10 dígitos: telefone fixo/residencial -> (##) ####-####
      // > 10 dígitos: celular -> (##) #####-####
      return numbers.length <= 10 ? '(##) ####-####' : '(##) #####-####';
    },
    computedValidationRules() {
      if (this.customRules) return this.customRules;
      return this.required ? 'required|telefone_valido' : 'telefone_valido';
    }
  },
  watch: {
    value(newVal) {
      if (newVal !== this.innerValue) {
        this.innerValue = newVal || '';
      }
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
    }
  }
};
</script>

<style scoped>
.app-input-telefone {
  display: inline-block;
}
</style>
